export default __webpack_public_path__ + "static/Lucerne_Switzerland-2dda36cc52fc78e358d285905a0db057.jpg";